import axios, { AxiosRequestConfig } from 'axios';

export class DeleteYourSnappiiAccountForm {
    public store;
    public recaptchaResponse = null;
    public recaptchaId = null;

    async init(store) {
        this.store = store;
        await this._addEventsForButtons();
    }

    async _addEventsForButtons() {
        const loginButton: HTMLButtonElement = document.querySelector('.delete-your-snappii-account-form__button--log-in');

        if (loginButton) {
            loginButton.addEventListener('click', (event) => {
                this.store.dispatch('modalManagementSystem/addModalWindow', {
                    content: 'SignInForm',
                });
            });
        }

        const deleteForm: HTMLFormElement = document.querySelector('.delete-your-snappii-account-form__form');

        if (deleteForm) {
            const recaptchaElement: HTMLButtonElement = document.querySelector('.delete-your-snappii-account-form__recaptcha');

            const unsubscribe = this.store.subscribe((mutation, state) => {
                if (mutation.type === `recaptcha/recaptchaLoaded`) {
                    this.recaptchaId = grecaptcha.enterprise.render(recaptchaElement, {
                        'sitekey': this.store.state.recaptcha.reCaptchaSiteKey,
                        'callback': (response) => {
                            this.recaptchaResponse = response;
                        },
                        'expired-callback': () => {
                            this.recaptchaResponse = null;
                        }
                    }); 
                }
            })

            deleteForm.addEventListener('submit', async (event) => {
                event.preventDefault();

                if (this.recaptchaResponse == null) {
                    console.log('Please check the captcha box to proceed registration')
                }

                const deleteAccountRequestFormData = new FormData();
                deleteAccountRequestFormData.append('g-recaptcha-response', this.recaptchaResponse);
                deleteAccountRequestFormData.append('type', 'accountDeletionRequest');

                const deleteAccountRequestConfig: AxiosRequestConfig = {
                    method: 'post',
                    url: 'handlers/registration.ashx',
                    data: deleteAccountRequestFormData,
                    headers: { 'Content-Type': 'multipart/form-data' },
                };

                try {
                    //doitForYou.classList.add('do-it-for-you--loading');

                    let response = await axios(deleteAccountRequestConfig);

                    if (response.status === 200) {
                        const rootContainer: HTMLElement = document.querySelector('.delete-your-snappii-account-form__layout');
                        rootContainer.innerHTML = `
                            <div class="delete-your-snappii-account-form__result-container">
                                <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72Z" fill="#00CB20"/>
                                <path d="M24 36L32 44L48 28" stroke="white" stroke-width="6" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>

                                <p class="delete-your-snappii-account-form__result-description">
                                    Your request has been sent. Expect the reply from our team via email. Make sure you check your spam folder.
                                </p>
                            
                                 <a class="delete-your-snappii-account-form__link" href="/">
                                    <span class="delete-your-snappii-account-form__link-text">Go to Home page</span>
                                </a>
                            </div>
                        `   

                    }

                    //doitForYou.classList.remove('do-it-for-you--loading');
                    //doitForYou.classList.add('do-it-for-you--request-completed');
                } catch (e) {

                }


            })
        }

    }
}